import React, {useEffect, useRef} from "react";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import {FormControl, Typography} from "@material-ui/core";
import TextField from "../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../ui/DataSelect";
import {loadList} from "../../../../../../../Dict/Region/View/fetch";
import {getMunicipals} from "../../../../store/actions";
import TextMaskPhone from '../../../../../../../ui/TextField/TextMaskPhone';
import TextMaskSnils from '../../../../../../../ui/TextField/TextMaskSnils';
import TextMaskInn from "../../../../../../../ui/TextField/TextMaskInn";
import Progress from "../../../../../../../ui/Progress";
import ButtonDropDown from "../../../../../../../ui/ButtonDropDown";
import ViewPageLayout from "../../../../../../../ui/ViewPageLayout";

const initialInfo = {
  firstName : "",
  middleName : "",
  lastName : "",
  firstNameR : "",
  middleNameR : "",
  lastNameR : "",
  firstNameD : "",
  middleNameD : "",
  lastNameD : "",
  sex : -1,
  birthday : "",
  snils : "",
  inn : "",
  email : "",
  phone : "",
  phoneExtra : "",
  legalAddress: "",
  postAddress: "",
  region : -1,
  municipal : -1
};

const sexSelect = [
  {id: -1, name: "не указан"},
  {id: 0, name: "женский"},
  {id: 1, name: "мужской"},
];

const styles = () => ({
  container: {
    width: "100%",
    marginTop: "16px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const PersonEditForm = ({
  classes,
  personInfo,
  getMunicipals,
  municipalsList,
  disabled,
  onFormChange,
  loadList,
  regionsList = [],
  editmode,
  personId
}) => {
  const [data, setData] = React.useState(initialInfo);
  const prevData = usePrevious(data);
  const [blockNameVisible, setblockNameVisible] = React.useState(false);

  useEffect(() => {
    if (personInfo) {
      setData(personInfo);
    }
  }, [personInfo]);

    const onChange = (field, value) => {
      const newState = {
        ...data,
        [field]: value
      };

      setData(newState);
      onFormChange && onFormChange(newState);
    };

    React.useEffect(() => {
      loadList();
    }, []);

    React.useEffect(() => {
      if ((!prevData && data.region) || (data && prevData && data.region && data.region!==prevData.region)) {
        getMunicipals(data.region);
      }
    }, [data]);

    const handleCaseVisibleButton = () => {
      setblockNameVisible(!blockNameVisible);
    };

    return (
      <ViewPageLayout header="Личные данные">
        {data ? <>
          <Grid container spacing={1} className={classes.mainGrid}>
            <Grid item xs={6} md={3}>
              <TextField
                required
                value={data.lastName || ""}
                onChange={e => onChange("lastName", e.target.value)}
                label="Фамилия"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                required
                value={data.firstName || ""}
                onChange={e => onChange("firstName", e.target.value)}
                label="Имя"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.middleName || ""}
                onChange={e => onChange("middleName", e.target.value)}
                label="Отчество"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl className={classes.container}>
                <ButtonDropDown caption="Склонения ФИО"
                                onClick={handleCaseVisibleButton}
                                arrowUp={blockNameVisible}/>
              </FormControl>
            </Grid>

            {blockNameVisible &&
            <><Grid item xs={6} md={3}>
              <TextField
                value={data.lastNameR || ""}
                onChange={e => onChange("lastNameR", e.target.value)}
                label="Фамилия (родительный падеж)"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  value={data.firstNameR || ""}
                  onChange={e => onChange("firstNameR", e.target.value)}
                  label="Имя (родительный падеж)"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  value={data.middleNameR || ""}
                  onChange={e => onChange("middleNameR", e.target.value)}
                  label="Отчество (родительный падеж)"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6} md={3}>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  value={data.lastNameD || ""}
                  onChange={e => onChange("lastNameD", e.target.value)}
                  label="Фамилия (дательный падеж)"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  value={data.firstNameD || ""}
                  onChange={e => onChange("firstNameD", e.target.value)}
                  label="Имя (дательный падеж)"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  value={data.middleNameD || ""}
                  onChange={e => onChange("middleNameD", e.target.value)}
                  label="Отчество (дательный падеж)"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6} md={3}>
              </Grid>
            </>}

            <Grid item xs={6} md={3}>
              <DataSelect
                value={data.sex}
                onChange={value => onChange("sex", value.id)}
                label="Пол"
                dataSource={sexSelect}
                disabled={disabled || !editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.birthday || ""}
                onChange={e => onChange("birthday", e.target.value)}
                label="Дата рождения"
                format="dd.MM.yyyy"
                type="date"
                disabled={disabled}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.snils || ""}
                onChange={e => onChange("snils", e.target.value)}
                label="СНИЛС"
                disabled={disabled}
                inputComponent={TextMaskSnils}
                readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                value={data.inn || ""}
                onChange={e => onChange("inn", e.target.value)}
                label="ИНН"
                disabled={disabled}
                inputComponent={TextMaskInn}
                readOnly={!editmode}
              />
            </Grid>
          </Grid>

          <Typography style={{margin: "24px 0 8px 0"}} className={classes.heading}>Контактная информация</Typography>
          <Grid container spacing={1} className={classes.mainGrid}>
            <Grid item xs={6} md={3}>
              <TextField
              value={data.phone || ""}
              onChange={e => onChange("phone", e.target.value)}
              label="Телефон"
              disabled={disabled}
              inputComponent={TextMaskPhone}
              readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
              value={data.phoneExtra || ""}
              onChange={e => onChange("phoneExtra", e.target.value)}
              label="Дополнительный телефон"
              disabled={disabled}
              readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
              required
              value={data.email || ""}
              onChange={e => onChange("email", e.target.value)}
              label="E-mail"
              disabled={disabled}
              readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6} md={3}>
            </Grid>
          </Grid>

          <Typography style={{margin: "24px 0 8px 0"}} className={classes.heading}>Адреса</Typography>
          <Grid container spacing={1} className={classes.mainGrid}>
            <Grid item xs={6}>
              <TextField
              value={data.legalAddress || ""}
              onChange={e => onChange("legalAddress", e.target.value)}
              label="Адрес регистрации"
              disabled={disabled}
              readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <DataSelect
              value={data.region}
              onChange={value => onChange("region", value.id)}
              label="Регион"
              dataSource={regionsList}
              disableClearable={false}
              disabled={disabled || !editmode}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
              value={data.postAddress || ""}
              onChange={e => onChange("postAddress", e.target.value)}
              label="Почтовый адрес"
              disabled={disabled}
              readOnly={!editmode}
              />
            </Grid>
            <Grid item xs={6}>
              {(municipalsList && municipalsList.length > 0) &&
              <DataSelect
                value={data.municipal}
                onChange={value => onChange("municipal", value.id)}
                label="Муниципальное образование"
                dataSource={municipalsList}
                disabled={disabled || !editmode || !data.region}
              />}
            </Grid>
          </Grid></> : <Progress/>}
      </ViewPageLayout>
    );
};

const mapStateToProps = state => ({
  municipalsList: state.persons.municipals,
  regionsList: state.dictRegionView.list
});

const mapDispatchToProps = dispatch => ({
  loadList: () => dispatch(loadList()),
  getMunicipals: (region)=>dispatch(getMunicipals(region))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PersonEditForm));
